import * as types from './types';
import { BakedBreadEntity, bakedBreadInitialEntity } from 'src/firebase/db/BakedBreads';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetBakedBreads
  | SuccessGetBakedBreads
  | FailGetBakedBreads
  | GetReservationBakedBreads
  | SuccessGetReservationBakedBreads
  | FailGetReservationBakedBreads
  | GetShopBakedBreads
  | SuccessGetShopBakedBreads
  | FailGetShopBakedBreads
  | SetDraft
  | SetBakedBreadListType
  | CreateBakedBread
  | SuccessCreateBakedBread
  | FailCreateBakedBread
  | UpdateBakedBread
  | SuccessUpdateBakedBread
  | FailUpdateBakedBread
  | UpdateBakedBreadOrders
  | SuccessUpdateBakedBreadOrders
  | FailUpdateBakedBreadOrders
  | InitBakedBread;

/**
 * Get
 */
interface GetBakedBreads {
  type: typeof types.GET_BAKED_BREADS;
  payload: string;
}
export const getBakedBreads = (payload: GetBakedBreads['payload']) => ({
  type: types.GET_BAKED_BREADS,
  payload,
});

interface SuccessGetBakedBreads {
  type: typeof types.SUCCESS_GET_BAKED_BREADS;
  payload: APISuccessfulResponse<BakedBreadEntity[]>;
}
export const successGetBakedBreads = (payload: SuccessGetBakedBreads['payload']) => ({
  type: types.SUCCESS_GET_BAKED_BREADS,
  payload,
});

interface FailGetBakedBreads {
  type: typeof types.FAIL_GET_BAKED_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetBakedBreads = (payload: FailGetBakedBreads['payload']) => ({
  type: types.FAIL_GET_BAKED_BREADS,
  payload,
});

/**
 * Get (Reservation Item Only)
 */
interface GetReservationBakedBreads {
  type: typeof types.GET_RESERVATION_BAKED_BREADS;
  payload: string;
}
export const getReservationBakedBreads = (payload: GetReservationBakedBreads['payload']) => ({
  type: types.GET_RESERVATION_BAKED_BREADS,
  payload,
});

interface SuccessGetReservationBakedBreads {
  type: typeof types.SUCCESS_GET_RESERVATION_BAKED_BREADS;
  payload: APISuccessfulResponse<BakedBreadEntity[]>;
}
export const successGetReservationBakedBreads = (
  payload: SuccessGetReservationBakedBreads['payload'],
) => ({
  type: types.SUCCESS_GET_RESERVATION_BAKED_BREADS,
  payload,
});

interface FailGetReservationBakedBreads {
  type: typeof types.FAIL_GET_RESERVATION_BAKED_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetReservationBakedBreads = (
  payload: FailGetReservationBakedBreads['payload'],
) => ({
  type: types.FAIL_GET_RESERVATION_BAKED_BREADS,
  payload,
});

/**
 * Get (from shops ref)
 */
interface GetShopBakedBreads {
  type: typeof types.GET_SHOP_BAKED_BREADS;
  payload: string;
}
export const getShopBakedBreads = (payload: GetShopBakedBreads['payload']) => ({
  type: types.GET_SHOP_BAKED_BREADS,
  payload,
});

interface SuccessGetShopBakedBreads {
  type: typeof types.SUCCESS_GET_SHOP_BAKED_BREADS;
  payload: APISuccessfulResponse<BakedBreadEntity[]>;
}
export const successGetShopBakedBreads = (payload: SuccessGetShopBakedBreads['payload']) => ({
  type: types.SUCCESS_GET_SHOP_BAKED_BREADS,
  payload,
});

interface FailGetShopBakedBreads {
  type: typeof types.FAIL_GET_SHOP_BAKED_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetShopBakedBreads = (payload: FailGetShopBakedBreads['payload']) => ({
  type: types.FAIL_GET_SHOP_BAKED_BREADS,
  payload,
});

/**
 * Draft
 */
interface SetDraft {
  type: typeof types.SET_DRAFT;
  payload: BakedBreadEntity;
}
export function setDraft(payload?: SetDraft['payload']) {
  return {
    type: types.SET_DRAFT,
    payload: payload || bakedBreadInitialEntity,
  };
}

/**
 * List type (for listing page)
 */
interface SetBakedBreadListType {
  type: typeof types.SET_BAKED_BREADS_LIST_TYPE;
  payload: 'list' | 'detail';
}
export function setBakedBreadListType(payload?: SetBakedBreadListType['payload']) {
  return {
    type: types.SET_BAKED_BREADS_LIST_TYPE,
    payload,
  };
}

/**
 * Create
 */
interface CreateBakedBread {
  type: typeof types.CREATE_BAKED_BREAD;
  payload: BakedBreadEntity;
}
export const createBakedBread = (payload: CreateBakedBread['payload']) => ({
  type: types.CREATE_BAKED_BREAD,
  payload,
});

interface SuccessCreateBakedBread {
  type: typeof types.SUCCESS_CREATE_BAKED_BREAD;
  payload: APISuccessfulResponse<BakedBreadEntity>;
}
export const successCreateBakedBread = (payload: SuccessCreateBakedBread['payload']) => ({
  type: types.SUCCESS_CREATE_BAKED_BREAD,
  payload,
});

interface FailCreateBakedBread {
  type: typeof types.FAIL_CREATE_BAKED_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateBakedBread = (payload: FailCreateBakedBread['payload']) => ({
  type: types.FAIL_CREATE_BAKED_BREAD,
  payload,
});

/**
 * Update
 */
interface UpdateBakedBread {
  type: typeof types.UPDATE_BAKED_BREAD;
  payload: BakedBreadEntity;
}
export const updateBakedBread = (payload: UpdateBakedBread['payload']) => ({
  type: types.UPDATE_BAKED_BREAD,
  payload,
});

interface SuccessUpdateBakedBread {
  type: typeof types.SUCCESS_UPDATE_BAKED_BREAD;
  payload: APISuccessfulResponse<BakedBreadEntity>;
}
export const successUpdateBakedBread = (payload: SuccessUpdateBakedBread['payload']) => ({
  type: types.SUCCESS_UPDATE_BAKED_BREAD,
  payload,
});

interface FailUpdateBakedBread {
  type: typeof types.FAIL_UPDATE_BAKED_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failUpdateBakedBread = (payload: FailUpdateBakedBread['payload']) => ({
  type: types.FAIL_UPDATE_BAKED_BREAD,
  payload,
});

/**
 * Update order of baked_breads
 */
interface UpdateBakedBreadOrders {
  type: typeof types.UPDATE_BAKED_BREAD_ORDERS;
  payload: {
    id: string;
    order: number;
  }[];
}
export const updateBakedBreadOrders = (payload: UpdateBakedBreadOrders['payload']) => ({
  type: types.UPDATE_BAKED_BREAD_ORDERS,
  payload,
});
interface SuccessUpdateBakedBreadOrders {
  type: typeof types.SUCCESS_UPDATE_BAKED_BREAD_ORDERS;
  payload: APISuccessfulResponse<{ id: string; order: number }[]>;
}
export const successUpdateBakedBreadOrders = (
  payload: SuccessUpdateBakedBreadOrders['payload'],
) => ({
  type: types.SUCCESS_UPDATE_BAKED_BREAD_ORDERS,
  payload,
});

interface FailUpdateBakedBreadOrders {
  type: typeof types.FAIL_UPDATE_BAKED_BREAD_ORDERS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failUpdateBakedBreadOrders = (payload: FailUpdateBakedBreadOrders['payload']) => ({
  type: types.FAIL_UPDATE_BAKED_BREAD_ORDERS,
  payload,
});

interface InitBakedBread {
  type: typeof types.INIT_BAKED_BREAD;
}
export function initBakedBread() {
  return {
    type: types.INIT_BAKED_BREAD,
  };
}
